import * as userActions from '../user/actions';
import * as lawsFiltersActions from './actions';
import { REHYDRATE } from 'redux-persist';
import { computeDatesFilter, searchParams, sortedBy, isSavedFilters } from '~utils/filters';
import { priorityFilters } from '~redux_related/activeFeed/reducer';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    isFilters: false,
    isEqualsSaved: true, // флаг сравнения с сохраненными фильтрами в редьюсере user
    search: {
        value: '',
        dropdownValue: searchParams.titleAndText,
    },
    categories: null,
    themes: null,
    dates: {
        startDate: null,
        endDate: null,
        range: '',
    },
    documentTypes: null,

    projects: null,
    NPAs: null,
    deadlinesLost: null,
    deadlines: null,

    sources: null,
    priority: priorityFilters.all,
    importance: false,
    sortedBy: sortedBy.publicationDate,
    plan: false,
};

// Проверяет наличие фильтров на основе стэйта, возвращает bool
const computeIsFilters = (state) => {
    return Boolean(
        state.search.value ||
            state.categories ||
            state.themes ||
            state.dates.startDate ||
            state.dates.endDate ||
            state.documentTypes ||
            state.projects ||
            state.NPAs ||
            state.deadlinesLost ||
            state.deadlines ||
            state.sources ||
            state.groups ||
            state.importance ||
            state.plan
    );
};

// Удаляет элементы списка, возвращает новый список без удаленного элемента
// когда список становится пустым, возвращает null. Чистая функция.
// action берет из замыкания
const deleteItemFromList = (list, conditionCallback) => {
    // conditionCallback - колбек для сравнения элементов списка
    try {
        const itemToDeleteIndex = Array.isArray(list) && list.findIndex(conditionCallback);

        let updatedList = [];
        if (itemToDeleteIndex !== -1) {
            // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
            updatedList = [...list];
            updatedList.splice(itemToDeleteIndex, 1);
        }
        return updatedList && updatedList.length ? updatedList : null;
    } catch (err) {
        console.error(err.errorMessage);
    }
};

// переменная для промежуточного добавления обновленного state
// для корректного пересчета свойства isFilters
let updatedState = initialState;

export const lawsMyActionsFiltersReducer = (state = initialState, action) => {
    switch (action.type) {
        // Categories
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_CATEGORIES_FILTER:
            return {
                ...state,
                categories: action.categories,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_CATEGORY_FROM_FILTER:
            const listUpdatedCategories = deleteItemFromList(state.categories, (item) => item.id === action.id);
            updatedState = {
                ...state,
                categories: listUpdatedCategories,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters:
                    listUpdatedCategories || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_CATEGORIES_FILTER:
            updatedState = {
                ...state,
                categories: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Themes
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_THEMES_FILTER:
            return {
                ...state,
                themes: action.themes,
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_THEME_FROM_FILTER:
            const listUpdatedThemes = deleteItemFromList(state.themes, (item) => item.id === action.id);
            updatedState = {
                ...state,
                themes: listUpdatedThemes,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: listUpdatedThemes || computeIsFilters(updatedState) ? computeIsFilters(updatedState) : false, // god damn, надо с этим что-то делать
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_THEMES_FILTER:
            updatedState = {
                ...state,
                themes: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Dates
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_DATES_RANGE_FILTER:
            return {
                ...state,
                dates: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                    range: action.range,
                },
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DATES_RANGE_FILTER:
            updatedState = {
                ...state,
                dates: {
                    startDate: null,
                    endDate: null,
                    range: '',
                },
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Search
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_SEARCH_FILTER:
            return {
                ...state,
                search: {
                    ...state.search,
                    value: action.text,
                },
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_IS_TITLE_ONLY:
            return {
                ...state,
                search: {
                    ...state.search,
                    dropdownValue: action.value,
                },
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SEARCH_FILTER:
            updatedState = {
                ...state,
                search: {
                    value: '',
                    dropdownValue: searchParams.titleAndText,
                },
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SEARCH_ITEM:
            updatedState = {
                ...state,
                search: {
                    ...state.search,
                    value: '',
                },
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Document Types
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_DOCUMENT_TYPE_FILTER:
            return {
                ...state,
                documentTypes: action.documentTypes,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DOCUMENT_TYPE_FROM_FILTER:
            const listUpdatedDocumentTypes = deleteItemFromList(state.documentTypes, (item) => item.id === action.id);
            updatedState = {
                ...state,
                documentTypes: listUpdatedDocumentTypes,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DOCUMENT_TYPE_FILTER:
            updatedState = {
                ...state,
                documentTypes: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // NEW FILTERS:

        // Projects
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_PROJECTS_FILTER:
            return {
                ...state,
                projects: action.projects,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_PROJECT_FROM_FILTER:
            const listUpdatedProjects = deleteItemFromList(state.projects, (item) => item.id === action.id);
            updatedState = {
                ...state,
                projects: listUpdatedProjects,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_PROJECTS_FILTER:
            updatedState = {
                ...state,
                projects: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // NPAs
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_NPAS_FILTER:
            return {
                ...state,
                NPAs: action.NPAs,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_NPA_FROM_FILTER:
            const listUpdatedNPAs = deleteItemFromList(state.NPAs, (item) => item.id === action.id);
            updatedState = {
                ...state,
                NPAs: listUpdatedNPAs,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_NPAS_FILTER:
            updatedState = {
                ...state,
                NPAs: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Deadlines Lost
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_DEADLINES_LOST_FILTER:
            return {
                ...state,
                deadlinesLost: action.deadlinesLost,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DEADLINE_LOST_FROM_FILTER:
            const listUpdatedDeadlinesLost = deleteItemFromList(state.deadlinesLost, (item) => item.id === action.id);
            updatedState = {
                ...state,
                deadlinesLost: listUpdatedDeadlinesLost,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DEADLINES_LOST_FILTER:
            updatedState = {
                ...state,
                deadlinesLost: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Deadlines
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_DEADLINES_FILTER:
            return {
                ...state,
                deadlines: action.deadlines,
                isFilters: true,
                isEqualsSaved: false,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DEADLINE_FROM_FILTER:
            const listUpdatedDeadlines = deleteItemFromList(state.deadlines, (item) => item.id === action.id);
            updatedState = {
                ...state,
                deadlines: listUpdatedDeadlines,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_DEADLINES_FILTER:
            updatedState = {
                ...state,
                deadlines: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // NEW FILTERS END

        // Sources
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_SOURCES_FILTER:
            return {
                ...state,
                sources: action.listSources,
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SOURCE_FROM_FILTER:
            const listUpdatedSources = deleteItemFromList(state.sources, (item) => item.id === action.id);
            updatedState = {
                ...state,
                sources: listUpdatedSources,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_SOURCES_FILTER:
            updatedState = {
                ...state,
                sources: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Groups
        case lawsFiltersActions.LAWS_MY_ACTIONS_APPLY_GROUPS_FILTER:
            return {
                ...state,
                groups: action.listGroups,
                isEqualsSaved: false,
                isFilters: true,
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_GROUP_FROM_FILTER:
            const listUpdatedGroups = deleteItemFromList(state.groups, (item) => item.id === action.id);
            updatedState = {
                ...state,
                groups: listUpdatedGroups,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };
        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_GROUPS_FILTER:
            updatedState = {
                ...state,
                groups: null,
            };
            return {
                ...updatedState,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Importance
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_IMPORTANCE_FILTER:
            updatedState = {
                ...state,
                importance: action.value,
            };
            return {
                ...state,
                importance: action.value,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // SortedBy
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_SORT_FILTER:
            return {
                ...state,
                sortedBy: action.sortBy,
                isEqualsSaved: false,
            };

        // Plan
        case lawsFiltersActions.LAWS_MY_ACTIONS_CHANGE_PLAN_FILTER:
            updatedState = {
                ...state,
                plan: action.value,
            };
            return {
                ...state,
                plan: action.value,
                isEqualsSaved: false,
                isFilters: computeIsFilters(updatedState),
            };

        // Covid filters
        case lawsFiltersActions.APPLY_COVID_FILTERS:
            return {
                ...initialState,
                categories: action.filters.categories,
                themes: action.filters.themes,
                isEqualsSaved: false,
                isFilters: true,
            };

        case lawsFiltersActions.LAWS_MY_ACTIONS_REMOVE_ALL_FILTERS:
            return {
                ...initialState,
                sortedBy: state.sortedBy,
                isEqualsSaved: false,
            };

        case lawsFiltersActions.LAWS_MY_ACTIONS_SET_FILTERS:
            return Boolean(action.filters)
                ? {
                      ...action.filters,
                      isEqualsSaved: true,
                  }
                : initialState;

        case lawsFiltersActions.LAWS_MY_ACTIONS_SET_INITIAL_FILTERS:
            const newDatesFilter = computeDatesFilter(action.filters.dates);
            return Boolean(action.filters)
                ? {
                      ...action.filters,
                      dates: newDatesFilter,
                      isEqualsSaved: true,
                  }
                : initialState;

        case userActions.SAVE_LAWS_MY_ACTIONS_USER_FILTERS:
            return {
                ...state,
                isEqualsSaved: Boolean(action.filters),
            };

        case userActions.DELETE_LAWS_MY_ACTIONS_USER_FILTERS:
            return {
                ...state,
                isEqualsSaved: false,
            };

        case userActions.LOGIN:
            const lawsMyActionsSavedFilters = action.user.my_actions_feed_saved_filters;
            if (!isSavedFilters(lawsMyActionsSavedFilters)) return initialState;
            const { startDate, endDate, range } = computeDatesFilter(lawsMyActionsSavedFilters.dates);

            updatedState = {
                ...initialState,
                ...lawsMyActionsSavedFilters,
                search: {
                    dropdownValue: lawsMyActionsSavedFilters.search.dropdownValue,
                    value: lawsMyActionsSavedFilters.search.value,
                },
                dates: {
                    startDate,
                    endDate,
                    range,
                },
            };

            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
                isEqualsSaved: true,
            };

        case userActions.LOGOUT:
            return initialState;

        // При обновлении страницы сэттим фильтры, берем их из сохраненных
        // Ни разу не лагало, думаю, что экшен безопасный
        case REHYDRATE:
            const savedUserFilters =
                action.payload && action.payload.user && action.payload.user.lawsMyActionsSavedFilters;
            if (!isSavedFilters(savedUserFilters)) return initialState;
            const { startDate: start, endDate: end, range: rangeStr } = computeDatesFilter(savedUserFilters.dates);

            updatedState = {
                ...initialState,
                ...savedUserFilters,
                search: {
                    dropdownValue: savedUserFilters.search.dropdownValue,
                    value: savedUserFilters.search.value,
                },
                dates: {
                    startDate: start,
                    endDate: end,
                    range: rangeStr,
                },
            };

            return {
                ...updatedState,
                isFilters: computeIsFilters(updatedState),
                isEqualsSaved: true,
            };

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsMyActionsFilters/reducer.js